<template>
<div>
    <div v-if="$slots.header">
        <slot name="header"></slot>
    </div>
    <div v-else>
        <div v-if="showCondition">
            <Row v-if="myConfig.gridType === 'billGrid'" :gutter="4">
                <Col span='18'>
                    <ConditionBox :config="myConfig"  @conditionAction="conditionAction"  :dictData="dictData" modelType="billSearch"></ConditionBox>
                </Col>
                <Col span='6'>
                    <Row type="flex" justify="end" :gutter="8">
                        <Col>
                            <Toolbar :config="myToolConfig"  @doAction="doBatchAction" tooltype="batch" :moduleMethod="globalConfig.moduleMethod" ></Toolbar>
                        </Col>
                        <Col v-if="modulecode">
                            <Tooltip :content="modulecode" placement="left">
                                <CommonIcon size="32" color="#ffff3a" type="ios-information-circle-outline" />
                            </Tooltip>
                        </Col>
                    </Row>
                </Col>
        </Row>
        <Row v-else>
            <ConditionBox :config="myConfig"  @conditionAction="conditionAction"  :dictData="dictData" :isPop="isPop"></ConditionBox>
        </Row>
        </div>
    </div>
    <Table ref="table"  style="margin-top: 10px;" :loading="loading" :size="myConfig.tableSize"  :stripe="myConfig.showStripe" :border="myConfig.showBorder" :show-header="myConfig.showHeader" :columns="tableColumns"  :data="data" @on-sort-change="sortChagne"  @on-current-change="singleChagne":highlight-row="true" @on-row-dblclick="dbclick"  @on-row-click="click">
    </Table>
    <div v-if="$slots.footer">
        <slot name="footer"></slot>
    </div>
    <div  v-if="myConfig.showPage" style="margin: 5px;overflow: hidden">
        <div style="float: right;">
          <Page :total="myConfig.pageConfig.total_results"  :current="myConfig.pageConfig.page_no" :page-size="myConfig.pageConfig.page_size" :page-size-opts="myConfig.pageConfig.pageSizeList"  @on-page-size-change="changePageSize" @on-change="changePage"  show-total show-elevator show-sizer></Page>
        </div>
    </div>
</div>
</template>
<script>
import Base from './basicgrid.vue';
export default {
    name: 'basicviewgrid',
    extends: Base,
    data () {
        return {
            myConfig:{
                resources:'',
                method:'',
                response:'',
                searchParam:null,
                readOnly:true,
                multiSelect:true,
                bindSearchParam:'ph_key',
                showAll:false,
            },
            editRowFlag:false,
            singleData:{},
            searchBeforeSearchParam:{},
            order_field:'',
            order_direction:''
        };
    },
    methods: {
        customInit() {
            if (this.isPop) {
                if (this.myConfig.multiSelect) {
                    this.myConfig.showCheckBox = true;
                }
            }
           
            if (this.myConfig.gridType === 'billGrid') {
                this.getModuleMethod();
            }
        },
        conditionAction(temp) {
            let data = [];
            switch (temp.action) {
                case 'condition_search' :
                    if (temp.para) {
                        this.conditionSearchParam = this.$Method.copy(temp.para);
                    }
                    this.refurbish();
                    break;
                case 'condition_clear' :
                    this.conditionSearchParam = {};
                    break;
                case 'condition_ok' :
                    if (this.myConfig.multiSelect) {
                        data = this.getSelection();
                    } else {
                        if (this.singleData.currentRow) {
                            data.push(this.singleData.currentRow);
                        }
                    }
                    if (data.length === 0) {
                        this.alert('请选择');
                    } else {
                        temp.rows = data;
                        this.$emit('conditionAction',temp);
                    }
                    break;
                case 'condition_cancel' :
                    this.$emit('conditionAction',temp);
                    break;
            }
        },
        getSearchParam(obj) {
            let searchParam =Object.assign({},this.myConfig.searchParam,this.searchBeforeSearchParam);
            if (!searchParam) {
                searchParam = {};
            }
            if (this.myConfig.response === 'report') {
                searchParam = Object.assign({},searchParam,this.conditionSearchParam);
            } else {
                let tempSearchParam = {};
                for (let el in searchParam) {
                    if (this.conditionSearchParam[el]) {
                        tempSearchParam[el]={'$and':[]}; 
                        tempSearchParam[el]['$and'].push(searchParam[el]);
                        tempSearchParam[el]['$and'].push(this.conditionSearchParam[el]);
                    }
                }
                searchParam = Object.assign({},searchParam,this.conditionSearchParam);
                for (let el in tempSearchParam) {
                    delete searchParam[el];
                    searchParam['$and'] = el['$and'];
                }
            }

            if (this.myConfig.showPage) {
                if (obj && obj.page_no) {
                    searchParam.page_no = obj.page_no;
                } else {
                    searchParam.page_no  = 1;
                }
                searchParam.page_size = this.myConfig.pageConfig.page_size;
            }
            if (this.order_field) {
                searchParam.order_field = this.order_field;
                if (this.order_direction) {
                    searchParam.order_direction = this.order_direction;
                }
            }
            return searchParam;

        },
        setWhereParam(obj) {
            this.conditionSearchParam = this.$Method.copy(obj);
        },
    
        refurbish(obj) {
            this.loading = true;
            let self = this;
            this.singleData = {};
            self.data = [];
            self.asyncPost(self.myConfig.resources,self.myConfig.method,self.getSearchParam(obj),function(data) {
                if (data && data[self.myConfig.response]) {
                    if (self.myConfig.showAll) {
                        if (self.myConfig.rowAll) {
                            data[self.myConfig.response].splice(0,0,self.myConfig.rowAll);
                        }
                    }
                    self.data = data[self.myConfig.response];
                }
                if (data.total_results !== undefined) {
                    self.myConfig.pageConfig.total_results= Number(data.total_results);
                }
                self.loading = false;   
            },function() {
                self.loading = false;
            });
        },
        changePage (para) {
            let obj = {};
            obj.page_no=para;
            this.refurbish(obj);
        },
        changePageSize (para) {
            this.myConfig.pageConfig.page_size = para;
            this.refurbish();
        },
        sortChagne (para) {
            this.order_field = '';
            this.order_direction = '';
            if (this.config.searchParam) {
                if (this.config.searchParam.order_field) {
                    let tempField = this.config.searchParam.order_field.splice(',');
                    let tempDirection = [];
                    if (this.config.searchParam.order_direction) {
                        tempDirection = this.config.searchParam.order_direction.splice(',');
                        let tempDirectionNum = tempDirection.length;
                        for (let i=tempDirectionNum;i<tempField.length;i++) {
                            tempDirection.push('asc');
                        }
                    } else {
                        for (let i=0;i<tempField.length;i++) {
                            tempDirection.push('asc');
                        }
                    }
                    tempField.push(para.key);
                    tempDirection.push(para.order);
                    this.order_field = tempField.join();
                    this.order_direction = tempDirection.join();
                } else {
                    this.order_field = para.key;
                    this.order_direction = para.order;
                }
            }  else {
                this.order_field = para.key;
                this.order_direction = para.order;
            }
            this.refurbish();
        },
        singleChagne(currentRow,oldCurrentRow) {
            this.singleData = {};
            this.singleData.currentRow= currentRow;
            this.singleData.oldCurrentRow= oldCurrentRow;
        },
        removeRow(index) {
            this.data.splice(index, 1);
        },
        doBatchAction(obj) {
            if (obj.name !== 'addData') {
                let data = this.getSelection();
                if (data.length  === 0) {
                    this.alert('请至少选择一行');
                    return;
                }
                obj.data= data; 
            }
            this.$emit('doAction', obj);
        },
        add() {
            let obj = {};
            obj.name ='addData';
            this.$emit('doAction', obj);
        },
        setSearchBeforeSearchParam(obj) {
            this.searchBeforeSearchParam = Object.assign({},{},obj);
        },
        clearSearchBeforeSearchParam() {
            this.searchBeforeSearchParam = {};
        },
        popValueChanged (para) {
            let reData = [];
            let self = this;
            let searchParam = Object.assign({},self.getSearchParam(),para);
            self.synchroPost(self.myConfig.resources,self.myConfig.method,searchParam,function(data) {
                if (data && data[self.myConfig.response]) {
                    reData = data[self.myConfig.response];
                }  
            },null);
            return reData;
        },
    },
    mounted () {
        
    }
};
</script>


// WEBPACK FOOTER //
// src/components/grid/basicviewgrid.vue